import React, { useState, useEffect, useContext } from 'react';
import {Chart} from "chart.js";
import {format} from "date-fns";

import * as net from "../../lib/net";
import Dt_Cal from "../../lib/ui/dt_cal";
import ddo from "../../ddo";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Pos_Grp extends React.Component {
  constructor(props, context) {
    super(props);

    this.my_bar = null;
    this.store = props.store;
    this.pos = props.store.pos;

    this.state = {};
    this.state.today = new Date();
    this.state.seldate = new Date();
    this.state.avd = ddo.cache.avd;
    this.state.eka = [];
    this.state.aa = [];
    //context.posrend = this;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.st_grp();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 250;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  st_grp() {
      var dtt = format(this.state.today, "yyyy-MM-dd");
      var dts = format(this.state.seldate, "yyyy-MM-dd");
      if(dtt == dts) {
          this.st_today();
      }
      else {
          this.st_dt(dts);
      }
  }
  st_dt(dts) {
    var self = this;
      if(false) {
          var eka = [
                {grp: '01', text: 'GRP 01', belopp: '500000'},
                {grp: '02', text: 'GRP 02', belopp: '700000'},
                {grp: '03', text: 'GRP 03', belopp: '300000'}
            ];

      self.setState({ eka: eka }, self.bar_chart);
        //self.bar_chart();
        return;
      }
    var prm = {};
    prm.req = "pos.pos_eko.trh_tot";
    prm.avd = ddo.cache.avd;
    prm.fdat = dts;
    prm.tdat = dts;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({ eka: ret.rca }, () => self.bar_chart() );
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
  st_today() {
    var self = this;
      if(false) {
          var eka = [
                {grp: '01', text: 'GRP 01', belopp: '500000'},
                {grp: '02', text: 'GRP 02', belopp: '700000'},
                {grp: '03', text: 'GRP 03', belopp: '300000'}
            ];

      self.setState({ eka: eka }, self.bar_chart());
        //self.bar_chart();
        return;
      }
    var prm = {};
    prm.req = "pos.pos_eko.tr_tot";
    prm.avd = ddo.cache.avd;
    //prm.fplu = datum;
    //prm.tplu = datum;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        self.setState({ eka: ret.rca }, () => self.bar_chart() );
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
    bar_chart() {
      var lbls = [];
      var da = {};
      da.ink = [];
      da.ex = [];

      for(var row of this.state.eka) {
          if(row.grp == "tot") continue;
          lbls.push( row.text.toswe() );
          da.ink.push( row.belopp.cdipris() );
      }

        if(this.my_bar) this.my_bar.destroy();
        this.my_bar =  new Chart(document.getElementById("barchart"), {
            type: 'bar',
            data: {
				labels: lbls,
                datasets: [{
                    data: da.ink,
                    label: 'Belopp',
                    backgroundColor: "#4755AB",
                    borderWidth: 1,
                }]
            },
            options: {
                responsive: true,
                legend: {
                    display: false,
                    position: 'top'
                },
            }
        });
	};

  render() {
    return (
    <div className="web-p00 flex flex-col">

    <div className="web-p01">
    <div className="flex-row">
        <Dt_Cal startdatum="2020-02-01" getValue={(e)=> this.setState({seldate: e}) }/>
        <select className="form-control w250 hide" placeholder="Välj avdelning">
            { this.pos.deps.map((row, key) =>
            <option key={key} value={row.id}>{row.text}</option>
            )}
        </select>
        <div className="flex"></div>

        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.st_grp() } aria-label="System" >
            UPPDATERA
        </button>
    </div>
    <div className="divider_orange"></div>

    <div className="chart">
        <div className="row">
            <div className="col-lg-12 pr-lg-2 chart-grid">
                <div className="card text-center card_cdi">
                    <div className="card-header chart-grid__header">
                        Varugrupps Omsättning
                    </div>
                    <div className="card-body">
                        <div id="container">
                            <canvas id="barchart" height="100"></canvas>
                        </div>
                    </div>
                    <div className="card-footer text-muted chart-grid__footer">
                        Detaljer och djupdykning
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div className="web-row hide">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
                <th>Grp</th>
                <th>Text</th>
                <th>Belopp</th>
                <th>Procent</th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.eka.map((row, key) =>
            <tr key={ key } id={ row.grp } onDoubleClick={() => this.plu_edit(row) }>
                <td>{ row.grp }</td>
                <td>{ row.text }</td>
                <td>{ row.belopp.cdipris() }</td>
                <td>{ row.proc } %</td>
            </tr>
            )}
            </tbody>
        </table>
    </div>

    </div>
    </div>
  );
    }
}
export default Pos_Grp;
